
import { defineComponent } from "vue";
import router from "@/router";
import {
  GetMetricData,
  GetMetric,
  SummaryTitleByYear,
  NumberWithCommas,
  GetHighlight,
  ChangeOverTime,
  SourceURL,
  GetDateFromYear,
  GetMoneyFormat,
} from "@/utils";
import Spinner from "@/components/Spinner.vue";
import LineChart from "@/components/Chart/LineChart.vue";
import FilterTabs from "@/components/Chart/FilterTabs.vue";
import MetricTitle from "@/components/MetricTitle.vue";
import SectionTitle from "@/components/SectionTitle.vue";
import MetricGrid from "@/components/MetricGrid.vue";
import MetricStat from "@/components/MetricStat.vue";
import MetricSource from "@/components/MetricSource.vue";
import MetricHighlight from "@/components/MetricHighlight.vue";
import ChartOptions from "@/types/chartOptions";
import Metric from "@/types/metric";

export default defineComponent({
  data() {
    return {
      data: [] as Array<any>,
      selectedData: [] as Array<any>,
      metric: {} as Metric,
      summaryDate: new Date(),
      latestNumbers: "",
      miRank: "",
      yearChangePercent: "",
      highlight: "",
      filterOptions: [1, 5, 10, 0],

      //Chart setup
      options: new ChartOptions(),
      dataLabels: ["MI", "US"],
      dataProps: ["population_mi", "population_us"],
    };
  },
  components: {
    Spinner,
    LineChart,
    MetricTitle,
    SectionTitle,
    FilterTabs,
    MetricGrid,
    MetricStat,
    MetricSource,
    MetricHighlight,
  },
  methods: {
    debug(e: any) {
      console.log("debug", e);
    },
    handleFilter(option: any) {
      this.limitData(option);
    },
    limitData(years: number) {
      /* This is going to be custom for each metric, you need to cin some cases 
        convert the lable to a date. Then limit the date to the intended range */
      if (years == 0) {
        this.selectedData = this.data;
      } else if (years == 1) {
        let count = -2 ;
        this.selectedData = this.data.slice(count);
      } else {
        let count = -1 * (years);
        this.selectedData = this.data.slice(count);
      }
    },
    summaryTitle() {
      return SummaryTitleByYear(this.summaryDate);
    },
    sourceUrl() {
      return SourceURL(this.metric);
    },
  },
  async beforeMount() {
    //@ts-ignore
    const topic = router.currentRoute.value.name; // Get which metric by the route
    let _data = await GetMetricData(topic); // Get raw data from Socrata
    this.metric = GetMetric(topic); // Get metric configuration
    const lastItem: any = _data[_data.length - 1];

    // The data is raw population per year, so we need to do some calcs to determine the 
    _data.forEach((x:any, index:number) => {
      let metric = JSON.parse(JSON.stringify(x)); // make a clone, otherwise the variable is just a pointer to the array object;
      if (index > 0) {
        metric[this.dataProps[0]] = (((x[this.dataProps[0]] - _data[index - 1][this.dataProps[0]]) / _data[index - 1][this.dataProps[0]]) * 100).toFixed(2);
        metric[this.dataProps[1]] = (((x[this.dataProps[1]] - _data[index - 1][this.dataProps[1]]) / _data[index - 1][this.dataProps[1]]) * 100).toFixed(2);
        this.data.push(metric);
      }
    });

    this.selectedData = this.data; // initialize this to "lifetime" and update this variable when a range is selected

    //Add custom chart options
    this.options.scales.yAxis.ticks.callback = (label: any) => {
      return Number(label).toFixed(1) + "%";
    };

    // Adds a zero line to chart
    this.options.scales.yAxis.grid = {
      display: true,
      color: (context: any )=> context.tick.value == 0 ? "rgba(0, 0, 0, .25)" : "#FFFFFF",
    };

    // Update tooltip to show percent
    this.options.plugins.tooltip.callbacks.label = (context: any) => {
      const data = _data.filter((x:any) => x.date == context.raw.x)[0];
      const value = (context.dataset.label[0] === 'MI') ? data.population_mi : data.population_us;
      return `${context.dataset.label}: ${NumberWithCommas(value)} (${(context.parsed.y).toFixed(2)}% AGR)`
    }

    // Get summary data and hightlights
    this.summaryDate = GetDateFromYear(lastItem.date);
    this.latestNumbers = NumberWithCommas(lastItem[this.dataProps[0]]);
    this.miRank = lastItem.rank;
    this.yearChangePercent = this.data[this.data.length - 1][this.dataProps[0]];
    this.highlight = GetHighlight(this.data);
  },
});
